"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isConsumerEventType = exports.ConsumerEventTypes = exports.EVENT_TYPE_DISMISS = exports.EVENT_TYPE_FLOW_COMPLETE = exports.EVENT_TYPE_FLOW_INSERT = exports.EVENT_TYPE_FLOW_TRIGGER = exports.EVENT_TYPE_FLOW_READY = exports.EVENT_TYPE_SSO_SUCCESS = exports.EVENT_TYPE_REDIRECT = exports.EVENT_TYPE_SSO_INIT = exports.EVENT_TYPE_BACK = exports.EVENT_TYPE_SUBMIT = exports.EVENT_TYPE_STATE_ENTER = void 0;
// Events are always uppercase
exports.EVENT_TYPE_STATE_ENTER = 'STATE_ENTER';
exports.EVENT_TYPE_SUBMIT = 'SUBMIT';
exports.EVENT_TYPE_BACK = 'BACK';
exports.EVENT_TYPE_SSO_INIT = 'SSO_INIT';
exports.EVENT_TYPE_REDIRECT = 'REDIRECT';
exports.EVENT_TYPE_SSO_SUCCESS = 'SSO_SUCCESS';
exports.EVENT_TYPE_FLOW_READY = 'FLOW_READY';
exports.EVENT_TYPE_FLOW_TRIGGER = 'FLOW_TRIGGER';
exports.EVENT_TYPE_FLOW_INSERT = 'FLOW_INSERT';
exports.EVENT_TYPE_FLOW_COMPLETE = 'FLOW_COMPLETE';
exports.EVENT_TYPE_DISMISS = 'DISMISS';
exports.ConsumerEventTypes = [
    'FAILURE',
    'SUBMIT',
    'DISMISS',
    'BACK',
    'SSO_INIT',
    'SSO_SUCCESS',
    'REDIRECT',
    'FLOW_READY',
    'FLOW_TRIGGER',
    'FLOW_INSERT',
    'FLOW_COMPLETE',
    'STATE_ENTER',
    'CLOSE',
];
const isConsumerEventType = (event) => exports.ConsumerEventTypes.includes(event);
exports.isConsumerEventType = isConsumerEventType;
//# sourceMappingURL=event-types.js.map